module.exports = __webpack_public_path__ + "img/gombessa4.154396df.jpg";